import { ReactNode } from "react";
import colorMap from "colormap";
import styles from "./IRColorScale.module.less";
import {
  convertFahrenheitToUserPreference,
  getUnit,
} from "~/helpers/userPreference";
import {
  INFRARED_MAX_VALUE,
  INFRARED_MIN_VALUE,
} from "~/pages/copilotMessage/components/conversationDetail/components/conversationMessages/components/mikeMessage/components/irScanAnalysis/constants/ladleSensor";
import { Popover, Typography } from "antd";
import { UNITS } from "~/constants/unit";

export interface IRColorScaleProps {
  /**
   * @example jet, hsv, hot, cool, spring, summuer.... https://www.npmjs.com/package/colormap
   */
  colormap?: string;
  title?: string | ReactNode;
}

const IRColorScale = ({ colormap = "jet", title }: IRColorScaleProps) => {
  const colors = colorMap({
    colormap,
  });

  const imageColorScaleDefaultValues = {
    min: convertFahrenheitToUserPreference(INFRARED_MIN_VALUE),
    max: convertFahrenheitToUserPreference(INFRARED_MAX_VALUE),
  };

  return (
    <div className={styles.colorScale}>
      <div className={styles.titleContainer}>
        <Typography.Title level={2}>{title}</Typography.Title>
      </div>

      <Typography.Title level={2}>
        {`${imageColorScaleDefaultValues.min.toFixed(
          Number.isInteger(imageColorScaleDefaultValues.min) ? 0 : 1,
        )} ${getUnit(UNITS.CELSIUS)}`}
      </Typography.Title>
      <div style={{ height: "20px" }}>
        {colors.map((color, index) => (
          <Popover
            key={index}
            trigger={"hover"}
            placement="top"
            content={
              <span>
                {(
                  imageColorScaleDefaultValues.min +
                  (imageColorScaleDefaultValues.max -
                    imageColorScaleDefaultValues.min) *
                    (index / (colors.length - 1))
                ).toFixed(
                  Number.isInteger(imageColorScaleDefaultValues.min) ? 0 : 1,
                )}
                {getUnit(UNITS.CELSIUS)}
              </span>
            }
          >
            <div
              key={index}
              className={styles.colorDiv}
              style={{
                backgroundColor: color.toString(),
              }}
            ></div>
          </Popover>
        ))}
      </div>

      <Typography.Title level={2}>
        {`${imageColorScaleDefaultValues.max.toFixed(
          Number.isInteger(imageColorScaleDefaultValues.max) ? 0 : 1,
        )} ${getUnit(UNITS.CELSIUS)}`}
      </Typography.Title>
    </div>
  );
};

export default IRColorScale;
